import React from 'react';
import PropTypes from 'prop-types';
import { flow, isEmpty } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  buildMmyModelFamilyIdsPath,
  buildModelFamilyIdsModelYearsPath,
  VehicleEntities,
  VehicleModel,
} from 'client/data/models/vehicle-v2';
import { getPreprodInitialSearchFilter } from 'site-modules/core-page/utils/core-srp';
import { getFilteredModelYears } from 'site-modules/shared/utils/core-page/model-year-helpers';
import { MiniInventoryModule } from 'site-modules/shared/components/mini-inventory-module/mini-inventory-module';

function PreprodMiniInventoryUI({ vehicleParams, modelYears = null, isMobile = false }) {
  const hasYear = modelYears?.find(({ year }) => parseInt(year, 10) === vehicleParams.year);

  if (!hasYear) {
    return null;
  }

  return (
    <MiniInventoryModule
      className="mb-3"
      vehicleParams={vehicleParams}
      vehicleName={`New ${vehicleParams.makeName} ${vehicleParams.modelName}`}
      initialFilter={getPreprodInitialSearchFilter(vehicleParams)}
      isMobile={isMobile}
      hideEmpty
    />
  );
}

PreprodMiniInventoryUI.propTypes = {
  vehicleParams: PropTypes.shape({
    makeName: PropTypes.string,
    modelName: PropTypes.string,
    makeSlug: PropTypes.string,
    modelSlug: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  modelYears: PropTypes.arrayOf(VehicleEntities.ModelYearByFamilyId),
  isMobile: PropTypes.bool,
};

export const PreprodMiniInventory = flow(
  component =>
    connectToModel(component, {
      modelYears: bindToPath(
        ({ modelFamilyIds }) => !isEmpty(modelFamilyIds) && buildModelFamilyIdsModelYearsPath(modelFamilyIds),
        VehicleModel,
        (modelYears, { modelName }) => getFilteredModelYears(modelYears, modelName)
      ),
    }),
  component =>
    connectToModel(component, {
      modelFamilyIds: bindToPath(
        ({ params }) => buildMmyModelFamilyIdsPath({ make: params.make, model: params.model, year: params.year }),
        VehicleModel
      ),
    })
)(PreprodMiniInventoryUI);

export const PreprodMiniInventoryGraphql = connectToModel(PreprodMiniInventoryUI, {
  modelYears: bindToPath(
    ({ modelFamilyIds }) => buildModelFamilyIdsModelYearsPath(modelFamilyIds),
    VehicleModel,
    (modelYears, { modelName }) => getFilteredModelYears(modelYears, modelName)
  ),
});
